export interface DateSpan {
  from: string;
  to: string;
}

export interface AcceptedWindow extends DateSpan {
  weekdays: readonly string[];
}

export interface DateRules {
  accept: readonly AcceptedWindow[];
  exclude: readonly DateSpan[];
}

interface WireAcceptedRange extends DateSpan {
  appointment_days: readonly string[];
}

interface WireInterest {
  accept: readonly WireAcceptedRange[];
  exclude: readonly DateSpan[];
}

export function fromWireInterest(interest: WireInterest): DateRules {
  return {
    accept: interest.accept.map((range) => ({
      from: range.from,
      to: range.to,
      weekdays: range.appointment_days,
    })),
    exclude: interest.exclude.map((range) => ({ from: range.from, to: range.to })),
  };
}
